export const API_ENDPOINTS = {
    OutletInfo: {
        // GetAllRetailerUpdatePhone: '/services/app/OutletInfomationPhone/GetAllRetailerUpdatePhone?',
        GetAllRetailerUpdatePhone: '/OutletInfo/GetAllRetailerUpdatePhone?',
        GetAllRetailerUpdatePhone_Simple: '/OutletInfo/GetAllRetailerUpdatePhoneSimple',
        ExportTemplate: '/OutletInfo/ExportTemplate',
        ImportQueueRetailer: '/OutletInfo/ImportQueueRetailer',
        ExportCustomRetailer: '/OutletInfo/ExportCustomRetailer',
        GetRetailerForEdit: '/OutletInfo/GetRetailerForEdit?',
        UnlockOutlet: '/OutletInfo/UnlockOutlet?',
        EditOutlet: '/OutletInfo/EditOutlet',
        GetEditRequiredConfig: '/OutletInfo/GetEditRequiredConfig',
        CreateOrEditOutlet: '/OutletInfo/CreateOrEditOutlet',
        CreateOrEditDistributorAccount: '/OutletInfo/CreateOrEditDistributorAccount',
        DeleteOutLet: '/OutletInfo/DeleteOutLet?',
        IdentificationValidate: '/OutletInfo/IdentityValidate',
        TaxcodeValidate: '/OutletInfo/TaxcodeValidate',
        GetDistributorOutletsForExport: '/OutletInfo/GetDistributorOutletsForExport'
    },
    OutletInfoUpdateHistory: {
        GetAll: '/OutletInfo/GetOutletInfoUpdateHistory?'
    },
    File: {
        DownloadTempFile: '/File/DownloadTempFile?'
    },
    Image: {
        Upload: '/Image/Upload'
    },

    Salesman: {
        SearchAsync: '/Salesmans/GetSearchAsync',
        CreateOrEdit: '/Salesmans/CreateOrEditExt',
        AddToOrganizationUnit: '/OrganizationUnit/AddUsersToOrganizationUnit',
        GetForEdit: '/Salesmans/GetSalesmanForEdit',
        ResetPassword: '/Salesmans/ResetPasswordAsync',
        RegistDevice: '/Salesmans/RegistDeviceId',
        BatchDeleteAsync: '/Salesmans/BatchDeleteAsync',
        DownloadTemplate: '/Salesmans/DownloadTemplateExcel',
        GetSalesmansExportCustom: '/Salesmans/GetSalesmansExportCustom',
        DownloadTempFile: '/Salesmans/DownloadTempFile',
        Import: '/Import/Upload',
        ImportQueue: '/Salesmans/ImportQueue'
    },
    Role: {
        GetRoles: '/Role/GetRoles',
        Delete: '/Role/DeleteRole',
        GetRoleForEdit: '/Role/GetRoleForEdit'
    },
    OrganizationUnit: {
        GetAll: '/OrganizationUnit/GetOrganizationUnits',
        GetOrganizationUnitUsers: '/OrganizationUnit/GetOrganizationUnitUsers',
        Create: '/OrganizationUnit/CreateOrganizationUnit',
        Update: '/OrganizationUnit/UpdateOrganizationUnit',
        Move: '/OrganizationUnit/MoveOrganizationUnit',
        Delete: '/OrganizationUnit/DeleteOrganizationUnit',
        DeleteUser: '/OrganizationUnit/RemoveUserFromOrganizationUnit',
        FindUsers: '/OrganizationUnit/FindUsers',
        AddUsersToOrganizationUnit: '/Salesmans/AddUsersToOrganizationUnit'
    },
    Request: {
        GetAll: '/Request/GetAll',
        CreateFileExcel: '/Request/CreateFileExcel',
        GetDetail: '/Request/GetDetail',
        Upload: '/Image/Upload',
        CreateOrEdit: '/Request/CreateOrEdit',
        CreateComment: '/Request/CreateComment',
        DownloadFileComment: '/Request/DownloadFileComment',
        GetUpdateProfileRequestHistoryForEdit: '/UpdateProfileRequestHistory/GetUpdateProfileForView',
        GetMasterDetailByMultiCode: '/Request/GetMasterDetailByMultiCode',
        DownloadTempFile: '/Request/DownloadTempFile'
    },
    DeleteProfileRequests: {
        Search: '/DeleteProfileRequests/Search',
        ExportCustom: '/DeleteProfileRequests/ExportCustom',
        ReactivateProfile: '/DeleteProfileRequests/ReactivateProfile',
        RollbackDeleteUserRequestForApp: '/DeleteProfileRequests/RollbackDeleteUserRequestForApp',
        ApproveRequest: '/DeleteProfileRequests/ApproveRequest',
        RejectRequest: '/DeleteProfileRequests/RejectRequest'
    },
    Challenge: {
        GetListChallengeHeader: '/Challenge/GetListChallengeHeader?',
        GetChallengeHeaderForEdit: '/Challenge/GetChallengeHeaderForEdit?',
        GetListChallengeFollowForEdit: '/Challenge/GetListChallengeFollowForEdit?',
        GetListChallengeResultForEdit: '/Challenge/GetListChallengeResultForEdit?',
        CreateOrEditChallenge: '/Challenge/CreateOrEditChallenge',
        CreateOrEditChallengeFollow: '/Challenge/CreateOrEditChallengeFollow'
    },
    Campaign: {
        Ranks: {
            GetAll: '/Ranks/GetAll?',
            GetRankForEdit: '/Ranks/GetRankForEdit?',
            CreateOrEdit: '/Ranks/CreateOrEdit',
            Delete: '/Ranks/Delete',
        },
        RankTargets: {
            GetAll: '/RankTargets/GetAll?',
        },
        ChannelTypes: {
            GetAll: '/ChannelTypes/GetAll?',
        },
        Departments: {
            GetAll: '/Deparments/GetAll?',
        },
        RankTypes: {
            GetAll: '/RankTypes/GetAll?',
            GetRankTypeForEdit: '/RankTypes/GetRankTypeForEdit?',
            CreateOrEdit: '/RankTypes/CreateOrEdit',
            Delete: '/RankTypes/Delete',
        },
        Sales: {
            GetAll: '/Sales/GetAll',
            GetById: '/Sales/GetById',
            ExportTemplatePayment: '/Sales/ExportTemplatePayment',
            GetFileExcel: '/Sales/GetFileExcel',
            CreateOrEditExt: '/Sales/CreateOrEditExt',
            ImportQueuePayment: '/Sales/ImportQueuePayment'
        },
        GetAll: '/Campaign/GetAll?',
        GetCampaignForEdit: '/Campaign/GetCampaignForEdit?',
        SpecialSettings: {
            GetAllSpecialSettingInforMationByCampaignID: '/SpecialSettings/GetAllSpecialSettingInforMationByCampaignID?'
        },
        SenioritySettings: {
            GetAllForCampaign: '/SenioritySettings/GetAllForCampaign?'
        },
        Referrals: {
            GetAll: '/Referrals/GetAll?'
        },
        BaseSettings: {
            GetAllSettingParamsFields: '/BaseSettings/GetAllSettingParamsFields?'
        },
        EventSettings: {
            GetAllCustom: '/EventSettings/GetAllCustom?'
        },
        RankSettings: {
            GetAll: '/RankSettings/GetAll?'
        },
        ProductCategories: {
            GetAllProductCategory: '/ProductCategories/GetAllProductCategory?'
        },
        CampaignSettings: {
            CreateOrEdit: '/CampaignSettings/CreateOrEdit'
        },
        ExtendActiveSerial: {
            GetAll: '/ExtendActiveSerial/GetAll',
            ImportQueue: '/ExtendActiveSerial/ImportQueue'
        },
        SaleOrder: {
            GetAll: '/SaleOrder/GetAll'
        },
        Import: {
            CheckStatusImport: '/Import/CheckStatusImport',
            CheckFileExisted: '/Import/CheckFileExisted?',
            UploadFileAdjust: '/import/UploadFileAdjust'
        },
        CampaignManagement: {
            GetListCampaign: "/campaignmanagements/GetListCampaign",
            GetCampaignById: "/campaignmanagements/GetCampaignById",
            CreateOrEdit: "/campaignmanagements/CreateOrEdit",
            UpdateActive: "/campaignmanagements/UpdateActive",
            GetAllRewardItem: "/campaignmanagements/GetAllRewardItem",
            GetListRewardItem: "/campaignmanagements/GetListRewardItem",
            InsertCampaignReward: "/campaignmanagements/InsertCampaignReward",
            CloneCampaign: "/campaignmanagements/CloneCampaign",
        },
        RewardItem: {
            GetAllRewardItem: "/rewarditems/GetAllRewardItem",
            GetRewardItemDetail: "/rewarditems/GetRewardItemDetail",
            CreateOrEdit: "/rewarditems/CreateOrEdit",
            DeleteRewardItem: "/rewarditems/DeleteRewardItem",
        },
        RedemptionRequestManagement: {
            GetListRequest: "/redemptionrequestmanagements/GetListRequest",
            UpdateStatus: "/redemptionrequestmanagements/UpdateStatus",
            GetListRedemptionItemByRequestId: "/redemptionrequestmanagements/GetListRedemptionItemByRequestId",
            GetFileExcelHistory: "/redemptionrequestmanagements/GetFileExcelHistory",
        },
        Product: {
            GetProductForTree: '/Product/GetProductForTree'
        }
    },
    //CE-1596
    Marketing: {
        Article: {
            GetAll: '/Article/GetAll?',
            GetArticleForViewOrEditExtAsync: '/Article/GetArticleForViewOrEditExtAsync?',
            CreateOrEditAsync: '/Article/CreateOrEditAsync',
            Clone: '/Article/CloneArticle',
            BatchDeleteAsync: '/Article/BatchDeleteAsync'
        },
        Category: {
            GetAll: '/Category/GetAll?',
            GetAllExt: '/Category/GetAllExt?',
            GetCategoryForEdit: '/Category/GetCategoryForEdit?',
            GetAllArticleActvieAsync: '/Category/GetAllArticleActvieAsync?',
            CreateOrEditCategoryExt: '/Category/CreateOrEditCategoryExt',
            BatchDeleteAsync: '/Category/BatchDeleteCategoryAsync'
        },
        Communications: {
            GetAllExt: '/Communication/GetAllExt?',
            GetAllExtAsync: '/Communication/GetAllExtAsync',
            GetAllHashTag: '/Communication/GetAllHashTag',
            GetAllMasterDetailForCommunication: '/Communication/GetAllMasterDetailForCommunication',
            GetCommunicationForEditExt: '/Communication/GetCommunicationForEditExt?',
            GetAllToken: '/Communication/GetAllToken',
            CreateOrEditExt: '/Communication/CreateOrEditCommunicationExt',

            GetReportByCommunicationId: '/Communication/GetReportByCommunicationId',
            ExportCommunicationReportsToExcel: '/Communication/ExportCommunicationReportsToExcel',
            BatchDelete: '/Communication/BatchDeleteCommunication',
            Clone: '/Communication/CloneCommunication'
        },
        POSM: {
            GetAll: '/POSM/GetAll?',
            CreateFileExcel: '/POSM/CreateFileExcel'
        },
        SurveyInfo: {
            GetAll: '/SurveyInfo/GetAll?',
            Search: '/SurveyInfo/Search?',
            SearchExt: '/SurveyInfo/SearchExt?'
        }
    },
    ChannelConfigs: {
        GetAllChannelForLookupTableExt: '/ChannelConfig/GetAllChannelForLookupTableExt?'
    },
    Warehouse: {
        Sales: {
            ImportQueueDistribute: '/Sales/ImportQueueDistribute',
            ImportQueueDistributeReturn: '/Sales/ImportQueueDistributeReturn',
            GetAllSellOutDistributor: '/Sales/GetAllSellOutDistributor',
            ReturnOrExchangeSerial: '/Sales/ReturnOrExchangeSerial',
            UpdateDONumber: '/Sales/UpdateDONumber',
            GetFileExcelSummaryProduct: '/Sales/GetFileExcelSummaryProduct',
            GetFileExcelSummarySerial: '/Sales/GetFileExcelSummarySerial',
            GetSaleHistoryForExport: '/Sales/GetSaleHistoryForExport',
            GetFileExcelSAPSync: '/Sales/GetFileExcelSAPSync',
            GetFileExcelSerialInput: '/Sales/GetFileExcelSerialInput',
            GetFileExcelSerialInputDetail: '/Sales/GetFileExcelSerialInputDetail',
            GetFileExcelHistory: '/Sales/GetFileExcelHistory',
            CallPortal1Doi1SerialLoiAsync: '/Sales/CallPortal1Doi1SerialLoiAsync',
            InsertSerialAll: '/Sales/InsertSerialAll',
            CheckSerial: '/Sales/CheckSerial',
            InsertSerialNotInSystem: '/Sales/InsertSerialNotInSystem',
            RemoveSerialNotInSystem: '/Sales/RemoveSerialNotInSystem',
        },
        Products: {
            GetAll: '/Products/GetAll',
            IsDistributorRole: '/Products/IsDistributorRole',
            GetAllProductCode: '/Products/GetAllProductCode'
        },
        SerialTypes: {
            ImportQueue: '/SerialTypes/ImportQueue',
            GetListChangeHistory: '/SerialTypes/GetListChangeHistory',
            UpdateSerialType: '/SerialTypes/UpdateSerialType'
        },
        Import: {
            CheckStatusImport: '/Import/CheckStatusImport',
            CheckFileExisted: '/Import/CheckFileExisted?',
            UploadFileAdjust: '/import/UploadFileAdjust'
        },
        WarehouseSerialReceived: {
            WarehouseSerialReceived: '/WarehouseSerialReceiveds/WarehouseSerialReceived',
        },
        RuleGenerator: {
            GetAll: '/RuleGenerator/GetAll',
            ExportExcelRuleSerial: '/RuleGenerator/ExportExcelRuleSerial',
            GetById: '/RuleGenerator/GetById',
            CreateOrEdit: '/RuleGenerator/CreateOrEdit',
            Delete: '/RuleGenerator/Delete'
        },
        SerialProducer: {
            GetAll: '/SerialProducer/GetAll',
            CountSerialLimitInMonth: '/SerialProducer/CountSerialLimitInMonth',
            IsDuplicateMasssOrder: '/SerialProducer/IsDuplicateMasssOrder',
            GenerateSerialOverview: '/SerialProducer/GenerateSerialOverview',
            GenerateSerial: '/SerialProducer/GenerateSerial',
            IsRoleManufacturer: '/SerialProducer/IsRoleManufacturer',
            ExportTemplate: '/SerialProducer/ExportTemplate',
            ExportExcelSerialProducer: '/SerialProducer/ExportExcelSerialProducer',
            ImportQueue: '/SerialProducer/ImportQueue',
            Scan: '/SerialProducer/Scan'
        },
        SerialProducerScan: {
            ExportExcel: '/SerialProducerScan/ExportExcel',
            GetAll: '/SerialProducerScan/GetAll',
            Scan: '/SerialProducerScan/Scan'
        },
        SAPSerials: {
            CheckSerial: '/saleserial/CheckSAPSerial',
            CreateSaleVipShopTransaction: '/saleserial/CreateSaleVipShopTransaction',
            CreateSaleDisTransaction: '/saleserial/CreateSaleDisTransaction',
            CreateSaleInTransaction: '/saleserial/CreateSaleInTransaction',
            CreateSaleOutTransaction: '/saleserial/CreateSaleOutTransaction',
            CreateSaleBrandShopTransaction: '/saleserial/CreateSaleBrandShopTransaction',
            CreateSaleTechShopTransaction: '/saleserial/CreateSaleTechShopTransaction'
        },
        MasterDetails: {
            Search: '/MasterDetails/Search'
        },
        ActivationCode: {
            GenerateActiveCodeOverview: '/ActivationCode/GenerateActiveCodeOverview',
            GenerateActiveCode: '/ActivationCode/GenerateActiveCode',
        },
    },
    RegisterWarranty: {
        SearchForWarrantySerial: '/registerwarrantys/SearchForWarrantySerial',
        WarrantySerialsExportToExcel: '/registerwarrantys/WarrantySerialsExportToExcel',
        GetAllProvince: '/registerwarrantys/GetAllProvince',
        GetAllDistrict: '/registerwarrantys/GetAllDistrict',
        GetAllWard: '/registerwarrantys/GetAllWard',
        GetDistrictByProvince: '/registerwarrantys/GetDistrictByProvince',
        SearchComboHeaders: '/registerwarrantys/SearchComboHeaders',
        DeleteComboHeader: '/registerwarrantys/DeleteComboHeader',
        SaveCombo: '/registerwarrantys/SaveCombo',
        LoadCombo: '/registerwarrantys/LoadCombo',
        SearchFormulaHeaders: '/registerwarrantys/SearchFormulaHeaders',
        GetFormulaHeaderForEdit: '/registerwarrantys/GetFormulaHeaderForEdit',
        CreateOrEditFormulaHeader: '/registerwarrantys/CreateOrEditFormulaHeader',
        GetComboDetail: '/registerwarrantys/GetComboDetail',
        GetWarrantySerial: '/registerwarrantys/GetWarrantySerial',
        AdjustWarrantyDate: '/registerwarrantys/AdjustWarrantyDate',
        GetAllAdjustmentFile: '/registerwarrantys/GetAllAdjustmentFile',
        ImportAdjustment: '/registerwarrantys/ImportAdjustment',
        GetAllAdjustmentLog: '/registerwarrantys/GetAllAdjustmentLog',
        CancelRegisterWarranty: '/registerwarrantys/CancelRegisterWarranty',
        UnlockActive: '/registerwarrantys/UnlockActive',
        EditNote: '/registerwarrantys/EditNote',
        RegisterNew: '/registerwarrantys/RegisterNew',
        VerifySerial: '/registerwarrantys/VerifySerial',
        GetSerialWarrantyDetail: '/registerwarrantys/GetSerialWarrantyDetail',
        RegisterNewForApp: '/registerwarrantys/RegisterNewForApp',
        ImportQueue: '/registerwarrantys/ImportQueue',
    },
    MD: {
        Products: {
            GetAll: '/Products/GetAll?'
        },
        SAPSerials: {
            GetAll: '/SAPSerials/GetAll?'
        },
        Salemans: {
            GetAll: '/Salesmans/GetAll?'
        },
        ActivationCode: {
            GetAll: '/ActivationCode/GetAll?',
            CreateOrEdit: '/ActivationCode/CreateOrEdit',
            ExportFile: '/ActivationCode/ExportFile',
            ImportActiveCodeInsert: '/ActivationCode/ImportActiveCodeInsert',
            ImportActiveCodeUpdate: '/ActivationCode/ImportActiveCodeUpdate',
            GenerateActiveCodeOverview: '/ActivationCode/GenerateActiveCodeOverview',
            GenerateActiveCode: '/ActivationCode/GenerateActiveCode',
        },
        SupportFunction: {
            ResetNumberOfOTPSent: '/SupportFunction/ResetNumberOfOTPSent',
            EmergencyAccountLock: '/SupportFunction/EmergencyAccountLock'
        },
        Import: {
            CheckStatusImport: '/Import/CheckStatusImport',
            CheckFileExisted: '/Import/CheckFileExisted?',
            UploadFileAdjust: '/import/UploadFileAdjust'
        }
    },
    MasterDetail: {
        GetAll: '/masterdetails/GetAll',
        GetMasterDetailForEdit: '/masterdetails/GetMasterDetailForEdit',
        CreateOrEdit: '/masterdetails/CreateOrEdit',
        Delete: '/masterdetails/Delete',
        GetMasterDetailsToExcel: '/masterdetails/GetMasterDetailsToExcel',
        BatchDeleteAsync: '/masterdetails/BatchDeleteAsync',
        CreateOrEditUnsignAsync: '/masterdetails/CreateOrEditUnsignAsync',
        CreateOrEditCustom: '/masterdetails/CreateOrEditCustom',
        SearchCustom: '/masterdetails/SearchCustom',
        Search: '/masterdetails/Search',
        SearchCityByRegion: '/masterdetails/SearchCityByRegion',
        GetAllProductClass: '/masterdetails/GetAllProductClass',
        GetAllProductBrand: '/masterdetails/GetAllProductBrand',
        GetAllMasterDetail: '/masterdetails/GetAllMasterDetail',
        GetAllMasterDetails: '/masterdetails/GetAllMasterDetails',
        ImportQueue: '/masterdetails/ImportQueue',
        ExportCustom: '/masterdetails/ExportCustom',
        DeleteCustom: '/masterdetails/DeleteCustom',
        GetChild: '/masterdetails/GetChild',
        GetAllCategory: '/masterdetails/GetAllCategory',
        BatchDeleteMasterDetail: '/masterdetails/BatchDeleteMasterDetail',
        CreateOrEditCategory: '/masterdetails/CreateOrEditCategory',
        DeleteExt: '/masterdetails/DeleteExt',
        GetRegion: '/masterdetails/GetRegion',
        GetAllRegionAsync: '/masterdetails/GetAllRegionAsync',
        GetRegionByCodeAndLevelAsync: '/masterdetails/GetRegionByCodeAndLevelAsync',
    },
    MasterHeader: {
        GetAll: '/masterheaders/GetAll',
        GetMasterHeaderForEdit: '/masterheaders/GetMasterHeaderForEdit',
        CreateOrEdit: '/masterheaders/CreateOrEdit',
        Delete: '/masterheaders/Delete',
        GetMasterHeadersToExcel: '/masterheaders/GetMasterHeadersToExcel',
        CreateOrEditCustom: '/masterheaders/CreateOrEditCustom',
        Search: '/masterheaders/Search',
        DeleteCustom: '/masterheaders/DeleteCustom',
        DefaultOAAsync: '/masterheaders/DefaultOAAsync',
    },
    TargetAudienceHeaders: {
        GetAll: "/TargetAudienceHeaders/GetAll",
        GetTargetAudienceHeaderForEdit: "/TargetAudienceHeaders/GetTargetAudienceHeaderForEdit",
        CreateOrEdit: "/TargetAudienceHeaders/CreateOrEdit",
        Delete: "/TargetAudienceHeaders/Delete",
        GetTargetAudienceHeadersToExcel: "/TargetAudienceHeaders/GetTargetAudienceHeadersToExcel",
        CreateOrEditCustom: "/TargetAudienceHeaders/CreateOrEditCustom",
        Search: "/TargetAudienceHeaders/Search",
        GetTargetAudienceHeaderForEditCustom: "/TargetAudienceHeaders/GetTargetAudienceHeaderForEditCustom",
        BusinessEnqueue: "/TargetAudienceHeaders/BusinessEnqueue",
    },
};